import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { steamEndpointIds } from 'root/src/shared/steam/steam.constants';
export const saveSteamUserInfoEndpoint = {
    [steamEndpointIds.SAVE_STEAM_USER_INFO]: {
        endpointType: otherEndpointType,
    },
};
